import styled from "styled-components";

const FeaturesCss = styled.div`
  font-family: "Poppins";
  background: linear-gradient(180deg, #255862 0%, #163940 53.12%, #0a171a 100%);
  color: white;
  text-align: center;
  padding: 5rem 5% 3%;
  @media (max-width: 500px) {
    padding: 5rem 1% 1%;
  }
  .wrapper {
    .header {
      padding: 3rem 0 2rem 0;
      font-family: Poppins;
      font-style: normal;
      font-weight: 300;
      font-size: 45px;
      line-height: 90px;
      text-align: center;
      color: #ffffff;
      opacity: 0.9;
      b {
        font-weight: 500;
      }
      @media (max-width: 1700px) {
        font-size: 40px;
        padding: 1rem 0 1rem 0;
      }
      @media (max-width: 1400px) {
        font-size: 34px;
        padding: 1rem 0 1rem 0;
      }
      @media (max-width: 800px) {
        font-size: 30px;
        padding: 1rem 0 1rem 0;
      }
      @media (max-width: 500px) {
        font-size: 25px;
        padding: 1rem 0 1rem 0;
        line-height: 26px;
        width: 65vw;
        margin-left: auto;
        margin-right: auto;
      }
    }
    .features_div1 {
      display: flex;
      @media (max-width: 1000px) {
        display: none;
      }

      @media (max-width: 600px) {
        display: none;
      }
      align-items: center;
      text-align: center;
      justify-content: space-between;
      margin: 2% 1% 0%;
      .feature {
        text-align: center;
        display: flex;
        justify-content: space-between;
        padding-left: 4%;
        padding-right: 4%;
        height: 5vw;
        border-right: 1px solid rgba(253, 205, 11, 0.3);
        .f_img {
          flex: 0.15;
          align-items: center;
          margin: 15px;
          img {
            @media (max-width: 1700px) {
            }
          }
          @media (max-width: 1700px) {
            width: 2em;
            flex: 0.15;
          }

          @media (max-width: 1024px) {
            width: 2em;
            flex: 0.2;
          }
        }
        .f_text {
          flex: 0.75;
          font-family: Poppins;
          font-size: 23px;
          line-height: 40px;
          font-style: normal;
          font-weight: 400;
          letter-spacing: 0em;
          text-align: left;
          @media (max-width: 1700px) {
            font-size: 18px;
            line-height: 25px;
          }
          @media (max-width: 1024px) {
            font-size: 15px;
            line-height: 15px;
          }
        }
      }
    }

    .features_div1_tab {
      display: none;
      align-items: center;
      text-align: center;
      padding-bottom: 2rem;
      justify-content: space-between;
      margin: 2% 1% 0%;
      @media (max-width: 1000px) {
        display: flex;
      }
      @media (max-width: 600px) {
        display: none;
      }
      .feature {
        text-align: center;
        display: flex;
        justify-content: space-between;
        padding-left: 4%;
        padding-right: 4%;
        height: 5vw;
        border-right: 1px solid rgba(253, 205, 11, 0.3);
        .f_img {
          flex: 0.25;
          align-items: center;
          margin: 15px;
          img {
            @media (max-width: 1700px) {
            }
          }
          @media (max-width: 1700px) {
            width: 2em;
            flex: 0.15;
          }

          @media (max-width: 1024px) {
            width: 2em;
            flex: 0.2;
          }
        }
        .f_text {
          flex: 0.75;
          font-family: Poppins;
          font-size: 30px;
          font-style: normal;
          font-weight: 400;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;
          @media (max-width: 1700px) {
            font-size: 18px;
            line-height: 25px;
          }
          @media (max-width: 1024px) {
            font-size: 15px;
            line-height: 15px;
          }
          @media (max-width: 700px) {
            font-size: 12px;
            line-height: 13px;
          }
        }
      }
    }
    .features_div2 {
      display: flex;
      @media (max-width: 1000px) {
        display: none;
      }
      @media (max-width: 600px) {
        display: none;
      }
      align-items: center;
      text-align: center;
      justify-content: space-between;
      margin: 0% 10% 0%;
      .feature {
        height: 5vw;
        border-right: 1px solid rgba(253, 205, 11, 0.3);
        text-align: center;
        display: flex;
        justify-content: space-between;
        padding-left: 3%;
        padding-right: 3%;
        margin: 3% 2% 3%;
        .f_img {
          flex: 0.15;
          align-items: center;
          padding: 5%;
          img {
            @media (max-width: 1700px) {
            }
          }
          @media (max-width: 1700px) {
            width: 2em;
            flex: 0.15;
          }
          @media (max-width: 1024px) {
            width: 2em;
            flex: 0.2;
          }
        }
        .f_text {
          flex: 0.75;
          font-family: Poppins;
          font-size: 23px;
          line-height: 40px;
          font-style: normal;
          font-weight: 400;
          letter-spacing: 0em;
          text-align: left;
          @media (max-width: 1700px) {
            font-size: 18px;
            line-height: 25px;
          }
          @media (max-width: 1024px) {
            font-size: 15px;
            line-height: 15px;
          }
        }
      }
    }
    .features_div2_tab {
      display: none;
      @media (max-width: 1000px) {
        display: flex;
      }
      @media (max-width: 600px) {
        display: none;
      }
      align-items: center;
      text-align: center;
      justify-content: space-between;
      margin: 0% 10% 0%;
      .feature {
        flex: 0.5;
        margin-top: 2rem;
        height: 5vw;
        border-right: 1px solid rgba(253, 205, 11, 0.3);
        text-align: center;
        display: flex;
        justify-content: space-between;
        padding-left: 3%;
        padding-right: 3%;
        margin: 3% 2% 3%;
        .f_img {
          flex: 0.25;
          align-items: center;
          // padding: 5%;
          img {
            @media (max-width: 1700px) {
            }
          }
          @media (max-width: 1700px) {
            width: 2em;
            flex: 0.15;
          }
          @media (max-width: 1024px) {
            width: 2em;
            flex: 0.12;
          }
          @media (max-width: 800px) {
            width: 2em;
            height: 12px;
            flex: 0.1;
          }
        }
        .f_text {
          flex: 0.75;
          font-family: Poppins;
          font-size: 30px;
          font-style: normal;
          font-weight: 400;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;
          @media (max-width: 1700px) {
            font-size: 18px;
            line-height: 25px;
          }
          @media (max-width: 1024px) {
            font-size: 15px;
            line-height: 15px;
          }
          @media (max-width: 700px) {
            font-size: 12px;
            line-height: 13px;
          }
        }
      }
    }
    .features_div_mob {
      display: none;
      @media (max-width: 600px) {
        display: flex;
      }
      align-items: center;
      text-align: center;
      justify-content: space-around;
      margin: 0% 0% 0% 0%;
      flex-wrap: wrap;
      .feature {
        width: 40vw;
        // flex: 0.25;
        margin-top: 2rem;
        height: 6vw;
        border-right: 1px solid rgba(253, 205, 11, 0.3);
        text-align: center;
        display: flex;
        justify-content: space-between;
        .f_img {
          flex: 0.22;
          align-items: center;
          padding: 1%;
          img {
            @media (max-width: 380px) {
              width: 14px;
            }
            @media (max-width: 450px) {
              width: 15px;
            }
            @media (max-width: 600px) {
              width: 17px;
            }
          }
          @media (max-width: 1700px) {
            width: 2em;
            flex: 0.15;
          }
          @media (max-width: 1024px) {
            width: 2em;
            flex: 0.12;
          }
          @media (max-width: 800px) {
            width: 2.2em;
            height: 12px;
            flex: 0.13;
          }
          @media (max-width: 800px) {
            width: 2.2em;
            height: 12px;
            flex: 0.13;
          }
        }
        .f_text {
          flex: 0.78;
          font-family: Poppins;
          font-size: 30px;
          font-style: normal;
          font-weight: 400;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;
          @media (max-width: 1700px) {
            font-size: 18px;
            line-height: 25px;
          }
          @media (max-width: 1024px) {
            font-size: 15px;
            line-height: 15px;
          }
          @media (max-width: 700px) {
            font-size: 14px;
            line-height: 13px;
          }
          @media (max-width: 600px) {
            font-size: 14px;
            line-height: 14px;
            padding-right: 0.5rem;
          }
          @media (max-width: 350px) {
            font-size: 14px;
            line-height: 14px;
          }
        }
      }
    }
    .header2 {
      margin: 3% 0 0%;
      font-family: Poppins;
      font-size: 34px;
      font-style: normal;
      font-weight: 300;
      line-height: 40px;
      letter-spacing: 0em;
      text-align: center;
      @media (max-width: 1700px) {
        font-size: 30px;
        margin: 2% 0 0;
      }
      @media (max-width: 1400px) {
        font-size: 32px;
      }
      @media (max-width: 800px) {
        font-size: 28px;
      }
      @media (max-width: 500px) {
        font-size: 22px;
        padding: 2rem 0 1rem 0;
        line-height: 24px;
        width: 95vw;
        margin-left: auto;
        margin-right: auto;
        margin-top: 3rem;
      }
    }
    .time {
      display: flex;
      font-size: 34px;
      margin-top: 1rem;
      justify-content: center;
      @media screen and (max-width: 600px) {
        flex-direction: column;
        text-align: center;
      }
      @media (max-width: 1700px) {
        font-size: 30px;
        margin: 1% 0 2%;
      }
      @media (max-width: 1400px) {
        font-size: 32px;
      }
      @media (max-width: 800px) {
        font-size: 28px;
      }
      @media (max-width: 500px) {
        font-size: 22px;
        padding: 0.5rem 0 1rem 0;
        line-height: 24px;
        width: 95vw;
        margin: 1rem auto 1rem auto;
      }
    }
    .none {
      display: none;
    }
    .ends {
      color: $default-blue;

      font-weight: 300;
      margin-top: 5px;
    }
    .buyButton {
      width: 20rem;
      height: 4rem;
      margin-left: auto;
      margin-right: auto;
      margin-top: 2rem;
      font-family: Poppins;
      font-size: 26px;
      font-style: normal;
      font-weight: 500;
      line-height: 39px;
      letter-spacing: 0em;
      text-align: left;
      border-radius: 13px;
      color: #1c454c;
      background-color: #fdcd0b;
      transition: transform 0.3s;
      &:hover {
        background-color: #fdd224;
        transform: scale(1.1);
      }
      @media (max-width: 1700px) {
        font-size: 20px;
        width: 16rem;
        height: 3rem;
      }
      @media (max-width: 950px) {
        font-size: 12px;
        height: 2.5em;
        width: 14rem;
      }
      @media (max-width: 500px) {
        font-size: 13px;
        width: 12rem;
        height: 2.2rem;
        border-radius: 7px;
        margin-top: 1.5rem;
        margin-bottom: 2rem;
      }
    }
    .highlight {
      color: white;
      text-decoration: underline;
    }
    .timer {
      color: $default-blue;

      font-weight: 300;
      margin-top: 5px;
      display: flex;
      // flex-direction: column;
      align-items: center;
      justify-content: center;
      & > span {
        margin-right: 9px;
        position: relative;
        // width: 90px;
        text-align: start;
      }

      // @media screen and (max-width: 1600px) {
      //     & > span:first-child {
      //         font-size: 1.6em;
      //     }

      //     & > span:last-child {
      //         font-size: 3.4em;
      //     }
      // }
      // @media screen and (max-width: 1100px) {
      //     & > span:first-child {
      //         margin: auto;
      //     }
      // }
      // @media screen and (max-width: 450px) {
      //     & > span:last-child {
      //         font-size: 1.9rem;
      //     }
      // }
    }
    .unit {
      font-size: 15px;
      text-transform: lowercase;
      margin-left: -5px;
      font-weight: 500;
    }

    .buyButton_div {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 3rem;
      @media (max-width: 500px) {
        margin-top: 0;
        flex-direction: column;
        align-items: center;
      }
      // padding: 10px;
      .none {
        display: none;
      }
      .left {
        display: flex;
        flex-direction: column;
        flex: 0.5;
        .slider {
          padding: 0rem 4rem;
          .rollSlider {
            flex: 0.5;
          }
        }
        @media (max-width: 500px) {
          margin-top: 1rem;
        }
        .none {
          display: none;
        }
        .walletDetails {
          font-size: 0.8rem;
          @media (max-width: 600px) {
            font-size: 0.6rem;
            margin-bottom: 1rem;
          }
        }
        .buyButton {
          width: 20rem;
          height: 4rem;
          margin-left: auto;
          margin-right: auto;
          margin-top: 2rem;
          font-family: Poppins;
          font-size: 26px;
          font-style: normal;
          font-weight: 500;
          line-height: 39px;
          letter-spacing: 0em;
          text-align: left;
          border-radius: 13px;
          color: #1c454c;
          background-color: #fdcd0b;
          transition: transform 0.3s;
          &:hover {
            background-color: #fdd224;
            transform: scale(1.1);
          }
          @media (max-width: 1700px) {
            font-size: 20px;
            width: 16rem;
            height: 3rem;
          }
          @media (max-width: 950px) {
            font-size: 12px;
            height: 2.5em;
            width: 14rem;
          }
          @media (max-width: 500px) {
            font-size: 13px;
            width: 12rem;
            height: 2.2rem;
            border-radius: 7px;
            margin-top: 1.5rem;
            margin-bottom: 2rem;
          }
        }
      }
      .right {
        flex: 0.5;
        // margin-top: 3%;
        text-align: left;
        border-left: 1px solid rgba(253, 205, 11, 0.3);
        @media (max-width: 500px) {
          border-left: none;
        }
        ul {
          list-style: disc;
          width: 75%;
          // margin-right: auto;
          // margin-left: 4rem;
          margin: 0 auto 0 auto;
          li {
            font-size: 16px;
            @media (max-width: 1024px) {
              font-size: 14px;
            }
            @media (max-width: 800px) {
              font-size: 12px;
            }
            @media (max-width: 500px) {
              font-size: 10px;
            }
          }
          .bonus {
            font-size: 19px;
            @media (max-width: 1024px) {
              font-size: 17px;
            }
            @media (max-width: 800px) {
              font-size: 15px;
            }
            @media (max-width: 500px) {
              font-size: 13px;
            }
          }
        }
      }
    }

    .margin {
      margin-top: 4rem;
    }
    .downArrow {
      margin: 2% 0 1%;

      @media (max-width: 1700px) {
        transform: scale(0.6);
      }
    }
  }
`;

export default FeaturesCss;
